import React from 'react';

import { TextField, useRecordContext } from 'react-admin';

import { get, isEmpty } from 'lodash';

import { Typography } from '@mui/material';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { ForecastedTurnoverParameters } from '../../questionParameters';

const VALUE_LABEL = {
  [languages.SV]: 'Uppskattad årsomsättning för innevarande år',
  [languages.EN]: 'Estimated yearly turnover for the current year',
  [languages.DE]: 'Geschätzter Jahresumsatz für das laufende Jahr',
};

const ValueField = ({
  extraParameters,
}: {
  extraParameters?: ForecastedTurnoverParameters;
  language?: Languages;
}) => {
  const record = useRecordContext();

  const valueObj = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (isEmpty(valueObj)) return <Typography>-</Typography>;

  const currency = extraParameters?.fields?.currency?.choiceLabels?.[valueObj.currency]
    ?? valueObj.currency;
  const value = `${valueObj.value} ${currency}`;

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const ForecastedTurnover = ({ extraParameters }: {
  extraParameters?: ForecastedTurnoverParameters;
}) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (

    <Answer
      label={extraParameters?.label ?? extraParameters?.inputLabel ?? VALUE_LABEL[language]}
      source="forecastedTurnover"
      datapoint={conflictFields.FORECASTED_TURNOVER}
      identificationInfo={undefined}
    >
      <ValueField extraParameters={extraParameters} />
    </Answer>

  );
};

ForecastedTurnover.ValueField = ValueField;

export default ForecastedTurnover;
